import { useGetContentByFriendlyUrlQuery } from '@/redux/api/contentDeliveryAPI';
import { IContentExtended } from '@/lib/helpers/expandChildren';
import { extractFriendlyUrlFromPliUrl, simpleHash } from '@/utils/helpers';

type UseGetEcommPanelContentReturn = {
  content?: IContentExtended;
  isLoadingContent: boolean;
  isError?: boolean;
};

const useGetEcommPanelContent = (url?: string): UseGetEcommPanelContentReturn => {
  const friendlyUrl = extractFriendlyUrlFromPliUrl(url);

  const {
    data: content,
    isFetching: isLoadingContent,
    isError
  } = useGetContentByFriendlyUrlQuery(
    { friendlyUrl: friendlyUrl ?? '', userId: simpleHash('ANON') },
    { skip: !friendlyUrl }
  );

  return { content, isLoadingContent, isError };
};

export default useGetEcommPanelContent;
